// Feature flags for the public website.
//
// CATALOGUE_ENABLED: the product Catalogue is still being built. While false,
// every public entry point to it (nav link, home/hero/mission CTAs, footer
// links) is hidden so visitors don't reach the half-finished pages. The routes
// themselves stay registered so the team can still preview via direct URL
// (/catalogue, /product/:id). Flip to true to launch it.
export const CATALOGUE_ENABLED = false;
